// import Alert from 'src/components/spark-components/spark-alert/SparkAlert.vue'
// import Chart from 'src/components/spark-components/spark-chart/SparkChart.vue'
// import Chat from 'src/components/spark-components/spark-chat/SparkChat.vue'
// import DataTable from 'src/components/spark-components/spark-datatable/SparkDataTable.vue'
// import Feed from 'src/components/spark-components/spark-feed/SparkFeed.vue'
// import Modal from 'src/components/spark-components/spark-modal/SparkModal.vue'
// import MultiSelect from 'src/components/spark-components/spark-multi-select/SparkMultiSelect.vue'
// import PreLoader from 'src/components/spark-components/spark-preloader/SparkPreLoader.vue'
// import ProfileCard from 'src/components/spark-components/spark-profile-card/SparkProfileCard.vue'
// import ProgressBar from 'src/components/spark-components/spark-progress-bar/SparkProgressBar.vue'
import SparkBotaoBaixaFinanceiro from './spark-scrollbar/SparkBotaoBaixaFinanceiro.vue'

import SparkBuscarCidade from './spark-scrollbar/SparkBuscarCidade.vue'
import SparkBuscarCliente from './spark-scrollbar/SparkBuscarCliente.vue'
import SparkBuscarFinanceiro from './spark-scrollbar/SparkBuscarFinanceiro.vue'
import SparkBuscarFornecedor from './spark-scrollbar/SparkBuscarFornecedor.vue'
import SparkBuscarProduto from './spark-scrollbar/SparkBuscarProduto.vue'
import SparkBuscarServico from './spark-scrollbar/SparkBuscarServico.vue'
import SparkBuscarTransportador from './spark-scrollbar/SparkBuscarTransportador.vue'
import SparkBuscarVeiculo from './spark-scrollbar/SparkBuscarVeiculo.vue'
import SparkBuscarVendedor from './spark-scrollbar/SparkBuscarVendedor.vue'
import SparkBuscarCodigoNcm from './spark-scrollbar/SparkBuscarCodigoNcm.vue'
import SparkBuscarCodigoNcmTabela from './spark-scrollbar/SparkBuscarCodigoNcmTabela.vue'
import SparkBuscarTitular from './spark-scrollbar/SparkBuscarTitular.vue'
import SparkBuscarMotorista from './spark-scrollbar/SparkBuscarMotorista.vue'
import SparkBuscarListaMotorista from './spark-scrollbar/SparkBuscarListaMotorista.vue'

import SparkInputCep from './spark-scrollbar/SparkInputCep.vue'
import SparkInputCnpj from './spark-scrollbar/SparkInputCnpj.vue'
import SparkInputCpf from './spark-scrollbar/SparkInputCpf.vue'

import SparkInputDataHoraPicker from './spark-scrollbar/SparkInputDataHoraPicker.vue'
import SparkInputDataPicker from './spark-scrollbar/SparkInputDataPicker.vue'
import SparkInputDataPicker2 from './spark-scrollbar/SparkInputDataPicker2.vue'
import SparkInputDataFormat from './spark-scrollbar/SparkInputDataFormat.vue'
import SparkInputHoraPicker from './spark-scrollbar/SparkInputHoraPicker.vue'
import SparkInputHoraPickerSS from './spark-scrollbar/SparkInputHoraPickerSS.vue'

import SparkInputMonetario from './spark-scrollbar/SparkInputMonetario.vue'
import SparkInputMonetario10 from './spark-scrollbar/SparkInputMonetario10.vue'
import SparkInputPlaca from './spark-scrollbar/SparkInputPlaca.vue'
import SparkInputPeso from './spark-scrollbar/SparkInputPeso.vue'
import SparkInputPercentual from './spark-scrollbar/SparkInputPercentual.vue'
import SparkInputQuantidade from './spark-scrollbar/SparkInputQuantidade.vue'
import SparkInputQuantidade10 from './spark-scrollbar/SparkInputQuantidade10.vue'
import SparkInputTelefone from './spark-scrollbar/SparkInputTelefone.vue'
import SparkInputTelefoneCelular from './spark-scrollbar/SparkInputTelefoneCelular.vue'
import SparkInputTexto from './spark-scrollbar/SparkInputTexto.vue'
// import Scrollbar from './spark-scrollbar/SparkScrollbar.vue'
// import SimpleSelect from 'src/components/spark-components/spark-simple-select/SparkSimpleSelect.vue'
// import SocialNews from 'src/components/spark-components/spark-social-news/SparkSocialNews.vue'
// import Switch from 'src/components/spark-components/spark-switch/SparkSwitch.vue'
// import Tabs from 'src/components/spark-components/spark-tabs/SparkTabs.vue'
// import Widget from 'src/components/spark-components/spark-widget/SparkWidget.vue'
// import Wizard from 'src/components/spark-components/spark-wizard/SparkWizard.vue'

const SparkComponentsPlugin = {
  install (Vue, options) {
    // Vue.component(Alert.name, Alert)
    // Vue.component(Chart.name, Chart)
    // Vue.component(Chat.name, Chat)
    // Vue.component(DataTable.name, DataTable)
    // Vue.component(Feed.name, Feed)
    // Vue.component(Modal.name, Modal)
    // Vue.component(MultiSelect.name, MultiSelect)
    // Vue.component(PreLoader.name, PreLoader)
    // Vue.component(ProfileCard.name, ProfileCard)
    // Vue.component(ProgressBar.name, ProgressBar)
    Vue.component(SparkBotaoBaixaFinanceiro.name, SparkBotaoBaixaFinanceiro)

    Vue.component(SparkBuscarCidade.name, SparkBuscarCidade)
    Vue.component(SparkBuscarCliente.name, SparkBuscarCliente)
    Vue.component(SparkBuscarFinanceiro.name, SparkBuscarFinanceiro)
    Vue.component(SparkBuscarFornecedor.name, SparkBuscarFornecedor)
    Vue.component(SparkBuscarProduto.name, SparkBuscarProduto)
    Vue.component(SparkBuscarServico.name, SparkBuscarServico)
    Vue.component(SparkBuscarTransportador.name, SparkBuscarTransportador)
    Vue.component(SparkBuscarVeiculo.name, SparkBuscarVeiculo)
    Vue.component(SparkBuscarVendedor.name, SparkBuscarVendedor)
    Vue.component(SparkBuscarCodigoNcm.name, SparkBuscarCodigoNcm)
    Vue.component(SparkBuscarCodigoNcmTabela.name, SparkBuscarCodigoNcmTabela)
    Vue.component(SparkBuscarTitular.name, SparkBuscarTitular)
    Vue.component(SparkBuscarMotorista.name, SparkBuscarMotorista)
    Vue.component(SparkBuscarListaMotorista.name, SparkBuscarListaMotorista)
    Vue.component(SparkInputCep.name, SparkInputCep)
    Vue.component(SparkInputCnpj.name, SparkInputCnpj)
    Vue.component(SparkInputCpf.name, SparkInputCpf)
    Vue.component(SparkInputDataHoraPicker.name, SparkInputDataHoraPicker)
    Vue.component(SparkInputDataPicker.name, SparkInputDataPicker)
    Vue.component(SparkInputDataPicker2.name, SparkInputDataPicker2)
    Vue.component(SparkInputDataFormat.name, SparkInputDataFormat)
    Vue.component(SparkInputHoraPicker.name, SparkInputHoraPicker)
    Vue.component(SparkInputHoraPickerSS.name, SparkInputHoraPickerSS)
    Vue.component(SparkInputMonetario.name, SparkInputMonetario)
    Vue.component(SparkInputMonetario10.name, SparkInputMonetario10)
    Vue.component(SparkInputPlaca.name, SparkInputPlaca)
    Vue.component(SparkInputPeso.name, SparkInputPeso)
    Vue.component(SparkInputPercentual.name, SparkInputPercentual)
    Vue.component(SparkInputQuantidade.name, SparkInputQuantidade)
    Vue.component(SparkInputQuantidade10.name, SparkInputQuantidade10)
    Vue.component(SparkInputTelefone.name, SparkInputTelefone)
    Vue.component(SparkInputTelefoneCelular.name, SparkInputTelefoneCelular)
    Vue.component(SparkInputTexto.name, SparkInputTexto)
    // Vue.component(Scrollbar.name, SparkScrollbar)

    // Vue.component(Scrollbar.name, Scrollbar)
    // Vue.component(SimpleSelect.name, SimpleSelect)
    // Vue.component(SocialNews.name, SocialNews)
    // Vue.component(Switch.name, Switch)
    // Vue.component(Tabs.name, Tabs)
    // Vue.component(Widget.name, Widget)
    // Vue.component(Wizard.name, Wizard)
  }
}

export default SparkComponentsPlugin



// WEBPACK FOOTER //
// ./src/components/spark-components/spark-components-plugin.js